import React from "react";
import Select from "react-select";
import { DatePicker } from "antd";
import { ArrowLeft, Calendar } from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../../../Router/all_routes";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import { PlusCircle } from "react-feather";
const EditApplicant = () => {
  const route = all_routes;

  const gender = [
    { value: "Choose", label: "Choose" },
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const nationality = [
    { value: "Choose", label: "Choose" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "India", label: "India" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Update Profile{" "}
                  </h4>
                </ol>
              </nav>
              <h6>Update your Profile here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <RefreshIcon />
            <CollapesIcon />
            <li>
              <div className="page-btn">
                <Link
                  to={route.applicanttrackingapplicants}
                  className="btn btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back to Applicants
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <form className="add-product-form ">
          <div className="accordions-items-seperate" id="accordionExample">
            <div className="accordion-item border mb-4">
              <h2 className="accordion-header" id="headingOne">
                <div
                  className="accordion-button bg-white"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-controls="collapseOne"
                >
                  <div className="d-flex align-items-center justify-content-between flex-fill">
                    <h5 className="d-inline-flex align-items-center">
                      <i className="ti ti-users text-primary me-2" />
                      <span>Applicant Information</span>
                    </h5>
                  </div>
                </div>
              </h2>
              <div className="add-product accordion-body border-top">
                <div className="profile-pic-upload">
                  <div className="profile-pic">
                    <span>
                      <PlusCircle className="plus-down-add" />
                      Profile Photo
                    </span>
                  </div>
                  <div className="input-blocks mb-0">
                    <div className="image-upload mb-0">
                      <input type="file" />
                      <div className="image-uploads">
                        <h4>Change Image</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        First Name<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value="venky"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Last Name<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value="Nama"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Email<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value="venky@perennialcode.in"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Contact Number
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value="866736236"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-blocks">
                      <label className="form-label">
                        Date of Birth<span className="text-danger ms-1">*</span>
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Gender<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={gender}
                        placeholder="Choose"
                        defaultValue={gender[1]}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Nationality<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={nationality}
                        placeholder="Choose"
                        defaultValue={gender[2]}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="">
                      <label className="form-label">
                        Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type="password"
                          className="pass-input form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="">
                      <label className="form-label">
                        Confirm Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type="password"
                          className="pass-input form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="col-lg-12">
          <div className="d-flex align-items-center justify-content-end mb-4">
            <button type="button" className="btn btn-secondary me-2">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditApplicant;
